<template>
  <image-picker v-model="image" :label="label" remove-padding="true"/>
</template>
<script>
import ImagePicker from './ImagePickerModal';

export default {
  name: 'ImagePickerPanel',
  components: {
    ImagePicker
  },
  props: {
    value: {},
    label: {
      default: 'Image'
    }
  },
  computed: {
    image: {
      get() {
        if (this.value && !this.value.includes('linear-gradient(')) {
          return this.value.replace('url("', '').replace('")', '');
        }
        return this.value;
      },
      set(value) {
        const returnValue = value ? `url("${value}")` : null;
        this.$emit('input', returnValue);
        this.$emit('change', returnValue);
      }
    }
  }
};
</script>
